import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import { api, auth } from '@/f1/service';
// import 'vue2-datepicker/index.css';
import Language from './language';

//restful api
import { management } from '@/f1/service/api';

//i18n_data
import i18n_field from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components: { DatePicker, Language },
  data: () => ({ custom, so : default_opt() }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() { return i18n_field.i18n_fields[this.i18n] },
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'username,nickname,group.groupname',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      // var search = { target : 'user', cmd: 'list', limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [{name: 'group_id', value : auth.profile.group_id, op : '='}, {name : 'is_del' , value: false, op : '='}], or: [], sort: [] } }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [{name: 'group_id', value : auth.profile.group_id, op : '='}, {name : 'is_del' , value: false, op : '='}], or: [], sort: [] } }
      // order
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv.replace(/^\s+|\s+$/g,'%');
        console.info(value)
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: `%${value}%`, op: 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          case 'last_visit_sd' : search.body.and.push({name: 'last_visit', value: moment(value).valueOf(), op: '>=' }); break;
          case 'last_visit_ed' : search.body.and.push({name: 'last_visit', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: `%${value}%`, op: value ? 'like' : 'like' }); break;
        }
      }
      // console.info(search)
      // try { let rs = await api.member.Manager(search); console.info(rs); this.so.totalRows = rs.total; return rs.body; }
      try { let rs = await management.user.list(search); this.so.totalRows = rs.total; return rs.body;}
      catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) }
    },
    detail(item) { this.$router.push(`/user/${item.id}`); },
  },
  watch: { '$route' (to, from) { this.refresh() } },
  created() { console.log('[vue] user.list', 'created'); },
  destroyed() { console.log('[vue] user.list', 'destroyed'); },
  mounted() { console.log('[vue] user.list', 'mounted'); window.opt = this.so; },
}
